const imageBaseUrl = "/assets/img/logos/cameras/"
export const cameraLogos = [
    {
        title: "Unknown",
        imageUrl: null,
    },
    {
        title: "Mav",
        imageUrl: `${ imageBaseUrl }mav.svg`,
    },
    {
        title: "Mobotix",
        imageUrl: `${ imageBaseUrl }vaxtor.svg`,
    },
    {
        title: "hikvision",
        imageUrl: `${ imageBaseUrl }hikvision.svg`,
    },
    {
        title: "vreo",
        imageUrl: `${ imageBaseUrl }vreo.svg`,
    },
    {
        title: "DTK",
        imageUrl: `${ imageBaseUrl }dtk.png`,
    },
    {
        title: "Milesight",
        imageUrl: `${ imageBaseUrl }milesight.png`,
    },
    {
        title: "Plate Recognizer",
        imageUrl: `${ imageBaseUrl }plate-recognizer.png`,
    },
    {
        title: "Arvoo",
        imageUrl: `${ imageBaseUrl }arvoo.svg`,
    },
    {
        title: "Reolink",
        imageUrl: `${ imageBaseUrl }reolink.svg`,
    },
]